export const em = val => `${val}em`;
export const rem = val => `${val}rem`;

export const createStyle = objectStyle =>
  Object.entries(objectStyle)
    .map(([styleProps, styleValue]) => `${styleProps}:${styleValue};`)
    .join(' ');
